import { dataFetcher } from 'core/services/requestHandler';   

const saveLibraryBooking = async (data = {}, config = {}) => {
  return dataFetcher('bookings/saveLibraryBooking', data, {method: 'POST', ...config});
};

const getLibraryBookings = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookings', data, {...config});
};

const getLibraryBookingsByDate = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookingsByDate', data, {...config});
};

const getLibraryBookingDetails = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookingDetails', data, {...config});
};

const cancelLibraryBooking = async (data = {}, config = {}) => {
  return dataFetcher('bookings/cancelLibraryBooking', data, {...config});
};

const getLibraryBookingCancellationReasons = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookingCancellationReasons', data, {...config});
};

const getAvailableSeats = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getAvailableSeats', data, {...config});
};

const assignSeatsToBooking = async (data = {}, config = {}) => {
  return dataFetcher('bookings/assignSeatsToBooking', data, {method: 'POST', ...config});
};

const getBookingsByDueDate = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getBookingsByDueDate', data, {...config});
};

const updateLibraryBookingAmountDue = async (data = {}, config = {}) => {
  return dataFetcher('bookings/updateLibraryBookingAmountDue', data, {...config});
};

const getBookingsByProperty = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getBookingsByProperty', data, {...config});
};

export { saveLibraryBooking, getLibraryBookings, getLibraryBookingsByDate, getLibraryBookingDetails, cancelLibraryBooking,
  getLibraryBookingCancellationReasons, getAvailableSeats, assignSeatsToBooking, getBookingsByDueDate, updateLibraryBookingAmountDue,
  getBookingsByProperty
};
